module.exports = __webpack_public_path__ + "static/img/avatar-female.98a8ffee.png";